module.exports = __webpack_public_path__ + "img/rstep3f.211fbb53.png";